import React, { useState } from "react";
import { useHistory } from "react-router";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import axiosInstance from "../../axios";
import { emailVaildation } from "../../_helpers";
import { courseService } from "../../_services";

const ForgotPassword = () => {
  const { t } = useTranslation();
  const [email, setEmail] = useState("");
  const [validation, setValidation] = useState(false);
  const [errorMessage, setErrorMesssage] = useState("");
  const [manageConfirmation, setManageConfirmation] = useState(false);
  const [resendMailValue, setResendmailValue] = useState({});

  const handleChange = (e) => {
    setEmail(e.target.value);
  };

  const handleSendEmail = (e) => {
    e.preventDefault();
    setValidation(true);
    const ValidateEmail = emailVaildation(email) ? true : false;
    const data = {
      email: email,
    };
    if (ValidateEmail !== false) {
      setResendmailValue(data);
      courseService.profileForgetPassword(data).then((response) => {
        if (response?.data?.error === false) {
          setManageConfirmation(true);
        } else if (response?.data?.error === true) {
          setErrorMesssage(response.data.message);
        }
      });
    }
  };

  return (
    <div className="LoginPage">
      <div className="signupScreen">
        <div className="inner-wrapper ">
          <div className="left-section">
            <div className="section-header">Login</div>
            <h5>
              Connecting learners, educators and parents from around the world
              on a common inclusive &amp; truely multilingual platform.
            </h5>
          </div>

          <div className="right-section">
            <div className="form-wrapper">
              {!manageConfirmation ? (
                <>
                  <div className="right-top">
                    <h5>{t("Login")}</h5>
                    {/* <div className="finePrnt">
                      {t("notRegistered")}{" "}
                      <Link to="/register">{t("Signup")}</Link>
                    </div> */}
                  </div>

                  <form className="center" onSubmit={handleSendEmail}>
                    <div className="form-row">
                      <i className="icon icon-email"></i>
                      <input
                        placeholder={t("Please enter your email")}
                        aria-label="username"
                        type="text"
                        className={`${email === "" &&
                          validation === true &&
                          "validate-error"
                          }`}
                        value={email}
                        onChange={handleChange}
                      />
                    </div>
                    <p className="error-text">
                      {email !== "" &&
                        validation === true &&
                        emailVaildation(email) === false &&
                        "Please enter a valid email"}
                    </p>
                    <p>{errorMessage}</p>
                    <div className="form-row flex-wrapper">
                      <button className="btn btn-login">Reset Password</button>
                      <Link to="/login" className="btn btn-login">
                        Cancel
                      </Link>
                    </div>
                  </form>
                  <div className="text-center mt-3">
                    {t("notRegistered")}{" "}
                    <Link to="/register">{t("Signup")}</Link>
                  </div>
                </>
              ) : (
                <Confirmation resendMailValue={resendMailValue} />
              )}
            </div>

            {/* <div className="social-media-login">
              <div className="title-wrap">
                <div>{t("or")}</div>
                <div>{t("Connect with social media")}</div>
              </div>
              <div>
                <ul>
                  <li>
                    <a
                      title="Google link"
                      target="_blank"
                      rel="noopener noreferrer"
                      href="https://www.smiklearn.com/">
                      <i className="icon-google"></i>
                    </a>
                  </li>
                  <li>
                    <a
                      aria-label="Link to Facebook"
                      href="https://www.facebook.com/smiklearncom/"
                      rel="noopener noreferrer"
                      target="_blank"
                    >
                      <i className="icon-facebook"></i>
                    </a>
                  </li>
                  <li>
                    <a
                      aria-label="Link to Linked In"
                      href="https://www.linkedin.com/company/smiklearn/"
                      rel="noopener noreferrer"
                      target="_blank"
                    >
                      <i className="icon-linkedIn"></i>
                    </a>
                  </li>
                  <li>
                    <a
                      aria-label="Link to Twitter"
                      href="https://twitter.com/smiklearnglobal"
                      rel="noopener noreferrer"
                      target="_blank"
                    >
                      <i className="icon-twitter"></i>
                    </a>
                  </li>
                </ul>
              </div>
            </div> */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;

export function Confirmation({ resendMailValue }) {
  const [resendNotify, setResendNotify] = useState(false);
  const { t } = useTranslation();

  const handleResendEmail = async () => {
    if (resendMailValue) {
      setResendNotify(true);
      try {
        await axiosInstance.post("forgot-password", resendMailValue, {
          headers: {
            "Content-Type": "application/json",
          },
        });
      } catch (error) {
        console.error("Error resending verification email:", error);
      }
    }
  };

  return (
    <>
      <div className="right-top">
        <h5>{t("Forgot Password ?")}</h5>
        <div className="finePrnt">
          {t("notRegistered")} <Link to="/register">{t("Signup")}</Link>
        </div>
      </div>
      <div className="form-wrapper">
        <div className="center">
          <div className="form-row">
            <p className="form-text">
              Please check your email for a verification message. Click the link
              in the message to change your password.
            </p>
            <p className="form-text">Thank You !</p>
          </div>

          <div className="form-row flex-wrapper">
            <a
              href="javascript:;"
              onClick={handleResendEmail}
              className="resend-btn"
            >
              {resendNotify
                ? "verification mail send successfully"
                : "Resend verification email "}
            </a>
            <Link to="/login" className="close-btn">
              Close
            </Link>
          </div>
        </div>
      </div>
    </>
  );
}
